<template>
  <svg width="148" height="148" viewBox="0 0 148 148" fill="none">
    <rect x="0.5" y="0.5" width="147" height="147" rx="7.5" fill="#F4F5FA" />
    <rect x="0.5" y="0.5" width="147" height="147" rx="7.5" stroke="#e1e1e1" />
    <path
      d="M89.0331 94H91.2815C93.4426 94 94.5232 94 95.1189 93.55C95.6378 93.158 95.9589 92.5588 95.9977 91.9102C96.0422 91.1657 95.4428 90.2679 94.244 88.4722L87.5449 78.4376C86.5544 76.9539 86.0591 76.212 85.4348 75.9535C84.8891 75.7274 84.2757 75.7274 83.7299 75.9535C83.1057 76.212 82.6104 76.9539 81.6199 78.4376L79.9638 80.9182M89.0331 94L71.9325 69.3337C70.949 67.9152 70.4573 67.2059 69.8431 66.9565C69.3058 66.7384 68.7044 66.7384 68.1671 66.9565C67.5528 67.2059 67.0611 67.9152 66.0776 69.3337L52.8452 88.4206C51.5922 90.2278 50.9658 91.1315 51.0014 91.883C51.0325 92.5375 51.3512 93.1449 51.8724 93.5429C52.4709 94 53.5714 94 55.7726 94H89.0331ZM93.4837 60.6667C93.4837 64.3486 90.4948 67.3333 86.8077 67.3333C83.1207 67.3333 80.1317 64.3486 80.1317 60.6667C80.1317 56.9848 83.1207 54 86.8077 54C90.4948 54 93.4837 56.9848 93.4837 60.6667Z"
      stroke="#e1e1e1"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
